import { useForm as createUseForm } from "@ant-design-vue/use";
import { toRaw } from "vue";
import i18n from "../../../i18n";
import store from "../../../store";
import { checkAttribute } from "../../../utils/form";
import { createLoading } from "../../../utils/loading";
import { required, validateError } from "../../../utils/validate";
import { createFieldDate, createFieldSelect } from "../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/companyDocReject";

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = ({ props }) => {
    const { form } = props
    return !form ? {
        refInstead: null,
        startDate: null,
        endDate: null,
    } : lodash.cloneDeep(form);
};

export const createRules = () => {
    return {
        refInstead: [required],
        startDate: [required],
    };
};

export const createField = ({ data }) => {
    const useForm = data.useForm;
    const modelRef = useForm.modelRef;
    return [
        createFieldSelect({
            key: 'refInstead',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.userInstead.refInstead'),
            inputProp: () => ({
                value: modelRef.refInstead,
                'onUpdate:value': value => modelRef.refInstead = value,
                list: ({ searchQuery }) => store.dispatch("resource/v1/security/user/search", {
                    criteria: {
                        select: ["id", "version", "fullName"], page: 0, size: 20,
                        where: [{ name: "fullName", type: "String", operator: 'like', value: searchQuery || "" }],
                        sort: [{ name: "fullName", type: "ASC" }] }
                }).then(page => page.data),
                renderLabel: ({ item }) => <div>{item.fullName}</div>,
            }),
        }),
        createFieldDate({
            key: 'startDate',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.userInstead.startDate'),
            inputProp: () => ({ value: modelRef.startDate, 'onUpdate:value': value => modelRef.startDate = value })
        }),
        createFieldDate({
            key: 'endDate',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.userInstead.endDate'),
            inputProp: () => ({ value: modelRef.endDate, 'onUpdate:value': value => modelRef.endDate = value })
        }),
    ]
};

export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs, isLoading });
    data.rules = createRules({ props, data, refs, isLoading });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
};
